import { getAccessToken } from "./auth";
import CIQClient from "./ciq-client";
import { BASE_URL } from "./endpoints";

export type UpdateProjectDetailsPayload = {
  name?: string;
  number?: string;
  start_date?: string | null;
  end_date?: string | null;
  address?: string;
  details?: string;
  phase?: number;
};

export const getLBSTree = async (projectToken?: string): Promise<any> => {
  const subscriptionToken: any = getAccessToken();
  const config = {
    headers: { Authorization: `Bearer ${projectToken || subscriptionToken}` }
  };

  return CIQClient.post({
    url: `${BASE_URL}/locations/views/get-tree`,
    config
  });
};

export const updateProjectDetails = async (
  projectId: string,
  payload: UpdateProjectDetailsPayload,
  projectToken?: string
): Promise<any> => {
  const config = {
    headers: { Authorization: `Bearer ${projectToken}` }
  };

  return CIQClient.put({
    url: `${BASE_URL}/project/${projectId}/details`,
    data: payload,
    config,
    showError: false
  });
};

export const checkUIVersion = async () => {
  try {
    const subscriptionToken = getAccessToken();
    const response = await fetch(`${BASE_URL}/user/version?ts=${Date.now()}`, {
      method: "GET",
      headers: {
        api_key: "",
        Authorization: subscriptionToken ? `Bearer ${subscriptionToken}` : ""
      }
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return data;
  } catch {
    return null;
  }
};
